import { ApiFactory } from './agwasuite-api-factory';
import { ApiClientConfig } from './core/api-client-config';
import type { ClientConfigResult } from './agwa-api-model';

/**
 * Memoized accessor for the SPA runtime client configuration. The config is stable for the life of
 * the session (credentials rotate server-side, not per request), so fetch it once and share the
 * resolved promise. A failed fetch clears the cache so a later call can retry.
 */
let cached: Promise<ClientConfigResult> | null = null;

export function getClientConfig(): Promise<ClientConfigResult> {
  if (!cached) {
    cached = ApiFactory.authenticated(ApiClientConfig)
      .getClientConfig()
      .then((response) => {
        if (!response.success || !response.data) {
          throw new Error(
            response.error || 'Unable to load client configuration.'
          );
        }
        return response.data;
      })
      .catch((error) => {
        cached = null;
        throw error;
      });
  }
  return cached;
}
